import {
    GetFormalOffersResponse,
    GetMcaEstimatedScheduleResponse
} from '@iwoca/lapi-client/edge';

/**
 * Represents a non-nullable array of formal offers.
 */
export type TFormalOffers = NonNullable<
    GetFormalOffersResponse['data']['formal_offers']
>;

/**
 * Represents a non-nullable single formal offer object.
 */
export type TFormalOffer = NonNullable<TFormalOffers[number]>;

/**
 * The different types of relationship between formal offers
 */
export const FORMAL_OFFER_VARIATION_TYPES = ['IO'] as const;

/**
 * Represents the different types of relationship between formal offers
 */
export type TFormalOfferVariationType =
    (typeof FORMAL_OFFER_VARIATION_TYPES)[number];

/**
 * Represents an array of formal offer variation relationship trees
 */
export type TFormalOfferVariationTrees =
    GetFormalOffersResponse['data']['formal_offer_variation_relationship_trees'];

/**
 * Represents a single formal offer variation relationship tree
 * e.g., The base formal offer is Flexi12, and it has a child interest-only variation offer which is Flexi15
 */
export type TFormalOfferVariationTree = TFormalOfferVariationTrees[number];

/**
 * Represents an optional RBL schedule and loading status
 */
export type TRBLSchedule = {
    schedule: GetMcaEstimatedScheduleResponse | null | undefined;
    scheduleLoading: boolean;
};
